/**
 * Resumir nome do usuário, exibindo apenas os dois primeiros nomes,
 * ignorando preposições como "do", "da", "dos", "das", "de", etc.
 * @param {string} fullName - Nome completo do usuário
 * @returns {string} Nome resumido com apenas os dois primeiros nomes
 */
export const summarizeUserName = fullName => {
  if (!fullName || typeof fullName !== "string") {
    return "";
  }

  const prepositions = [
    "do",
    "da",
    "dos",
    "das",
    "de",
    "e",
    "em",
    "na",
    "no",
    "nas",
    "nos"
  ];

  const words = fullName.trim().split(/\s+/);
  const filteredWords = words.filter(
    word => !prepositions.includes(word.toLowerCase())
  );

  return filteredWords.slice(0, 2).join(" ");
};

export default {
  summarizeUserName
};
